export const commonDownloadFile = async (filePath: string, fileName: string): Promise<void> => {
    if (isSSR) {
        return;
    }

    const response = await fetch(filePath);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
};
